import { cx } from '@emotion/css'
import { shape, string } from 'prop-types'
import Progress from '../../atoms/progress'
import { LoadingWrapperStyled } from './loading-wrapper.styled'

const LoadingWrapper = ({ className, progressProps }) => {
	return (
		<LoadingWrapperStyled className={cx(className, 'loader')}>
			<Progress {...progressProps} />
		</LoadingWrapperStyled>
	)
}

LoadingWrapper.propTypes = {
	/**
	 * CSS class name(s)
	 */
	className: string,
	/**
	 * Progress props
	 */
	progressProps: shape(Progress.propTypes),
}

export default LoadingWrapper
